import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import QaiChallengeResponseViewModel from "./ViewModels/QaiChallengeResponseViewModel";

interface ITeamLeaderChallengeResponseControlsProps {
    qaiChallengeResponseViewModel: QaiChallengeResponseViewModel
    setQaiChallengeResponseViewModel: (newValue: QaiChallengeResponseViewModel) => void
}

export default function TeamLeaderChallengeResponseControls({ qaiChallengeResponseViewModel, setQaiChallengeResponseViewModel }: ITeamLeaderChallengeResponseControlsProps) {

    const respondToAllChallengesChangeHandler = () => {
        setQaiChallengeResponseViewModel({
            ...qaiChallengeResponseViewModel,
            isResponseToAllChallenges: !qaiChallengeResponseViewModel.isResponseToAllChallenges,
            isResponseToAllUnansweredChallenges: false
        })
    }

    const respondToAllUnansweredChallengesChangeHandler = () => {
        setQaiChallengeResponseViewModel({
            ...qaiChallengeResponseViewModel,
            isResponseToAllUnansweredChallenges: !qaiChallengeResponseViewModel.isResponseToAllUnansweredChallenges,
            isResponseToAllChallenges: false
        })
    }

    return (
        <Grid size={12}>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            value={qaiChallengeResponseViewModel.isResponseToAllChallenges}
                            onChange={respondToAllChallengesChangeHandler} />
                    }
                    label="Respond to all challenges" />
                <FormControlLabel
                    control={
                        <Checkbox
                            value={qaiChallengeResponseViewModel.isResponseToAllUnansweredChallenges}
                            onChange={respondToAllUnansweredChallengesChangeHandler} />
                    }
                    label="Respond to all unanswered challenges" />
            </FormGroup>
        </Grid>
    )
}